export default __webpack_public_path__ + "static/media/093-turn-left-2.7552d558.png";